/* Udsalg LP – størrelse-først filtrering (samlede halve EU-størrelser), brand, sortering, "Vis flere".
   v7: kun de første kort renderes på serveren; resten bygges i browseren fra #slc-data, når de skal vises. */
(function () {
(function () {
  var root = document.querySelector('.slc');
  if (!root) return;
  var src = root.getAttribute('data-src');
  var dataEl = document.getElementById('slc-data');
  if (dataEl) { try { init(JSON.parse(dataEl.textContent)); } catch (e) {} return; }
  if (!src) return;
  fetch(src, { credentials: 'same-origin' })
    .then(function (r) { return r.ok ? r.text() : Promise.reject(r.status); })
    .then(function (t) { init(JSON.parse(t)); })
    .catch(function () {});
})();

function init(D) {
  var root = document.querySelector('.slc');

  var grid = document.getElementById('slc-grid');
  var cards = new Array(D.length);
  var serverCards = [].slice.call(grid.querySelectorAll('.slc-card'));
  if (serverCards.length > D.length) return;
  var sizesEl = document.getElementById('slc-sizes');
  var edsEl = document.getElementById('slc-eds');
  var sortEl = document.getElementById('slc-sort');
  var countEl = document.getElementById('slc-count');
  var moreWrap = document.getElementById('slc-more-wrap');
  var moreBtn = document.getElementById('slc-more');
  var emptyEl = document.getElementById('slc-empty');
  var STEP = parseInt(root.getAttribute('data-initial'), 10) || 24;

  function store(k, v) { try { if (v == null) localStorage.removeItem(k); else localStorage.setItem(k, v); } catch (e) {} }
  function read(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function sread(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } }
  function swrite(k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} }
  function el(tag, cls, html) { var e = document.createElement(tag); if (cls) e.className = cls; if (html != null) e.innerHTML = html; return e; }
  function txt(tag, cls, s) { var e = document.createElement(tag); if (cls) e.className = cls; e.textContent = s; return e; }

  /* "EUR 37 1/3 - US 5" -> 37.333 -> spand "37"; 36 2/3 -> "36.5"; 38.5 -> "38.5" */
  function euNum(opt) {
    var s = String(opt || '').replace(/^EUR\s*/i, '').split(' - ')[0].split(' (')[0].trim();
    var m = s.match(/^(\d+(?:[.,]\d+)?)(?:\s+(\d)\/(\d))?$/);
    if (!m) return null;
    return parseFloat(m[1].replace(',', '.')) + (m[2] ? m[2] / m[3] : 0);
  }
  function bucket(n) { var b = Math.floor(n * 2 + 1e-6) / 2; return String(b); }
  /* Samlede størrelser: halve str. med få par lægges sammen med nabostørrelsen */
  var MERGE = { '35': '35.5', '37': '37.5', '39.5': '39', '41.5': '42', '43.5': '43', '46.5': '46' };
  var LABEL = {};
  function group(n) { var b = bucket(n); return MERGE[b] || b; }
  function label(s) { return LABEL[s] || s; }

  /* Forbered varianter: [opt, price, fmt, id, compare, fmtCompare] -> + spand */
  D.forEach(function (p) {
    p.vs = [];
    p.v.forEach(function (v) {
      var n = euNum(v[0]);
      if (n == null || n < 30 || n > 52) return;
      p.vs.push({ b: group(n), n: n, price: v[1], fmt: v[2], id: v[3], cmp: v[4], fcmp: v[5] });
    });
  });

  /* Kort-opsætning (fælles for server- og klient-renderede kort) */
  function setup(c) {
    var a = c.querySelector('a');
    c._a = a; c._base = a.getAttribute('data-base');
    c._now = c.querySelector('.slc-now');
    c._was = c.querySelector('.slc-was');
    c._disc = c.querySelector('.slc-tag--disc');
    var t = c.querySelector('.slc-track'), imgs = t ? t.querySelectorAll('img') : [];
    if (t && imgs.length > 1) {
      var dots = el('div', 'slc-dots', '<span class="on"></span><span></span>');
      dots.setAttribute('aria-hidden', 'true');
      t.parentNode.appendChild(dots);
      t.addEventListener('scroll', function () {
        var k = Math.round(t.scrollLeft / Math.max(1, t.clientWidth));
        [].forEach.call(dots.children, function (d, j) { d.classList.toggle('on', j === k); });
      }, { passive: true });
    }
    return c;
  }
  serverCards.forEach(function (c) {
    var i = parseInt(c.getAttribute('data-i'), 10);
    if (i >= 0 && i < D.length) cards[i] = setup(c);
  });

  function srcset(u) {
    if (!/width=\d+/.test(u)) return '';
    return [300, 450, 600].map(function (w) { return u.replace(/width=\d+/, 'width=' + w) + ' ' + w + 'w'; }).join(', ');
  }
  /* Byg et kort ud fra data (samme markup som serveren) */
  function make(i) {
    var p = D[i];
    var li = el('li', 'slc-card');
    li.setAttribute('data-i', i);
    var a = el('a');
    a.href = p.u; a.setAttribute('data-base', p.u);
    var media = el('div', 'slc-media'), track = el('div', 'slc-track');
    (p.m || []).forEach(function (u) {
      var img = document.createElement('img');
      img.loading = 'lazy'; img.decoding = 'async'; img.alt = p.n;
      var ss = srcset(u);
      if (ss) { img.srcset = ss; img.sizes = '(min-width: 990px) 25vw, (min-width: 750px) 33vw, 50vw'; }
      img.src = u;
      track.appendChild(img);
    });
    media.appendChild(track);
    media.appendChild(el('div', 'slc-tags', '<span class="slc-tag slc-tag--disc" hidden></span>'));
    var info = el('div', 'slc-info');
    info.appendChild(txt('p', 'slc-ed', p.g));
    info.appendChild(txt('h3', 'slc-name', p.n));
    var pr = el('p', 'slc-price');
    pr.appendChild(txt('span', 'slc-now', ''));
    pr.appendChild(el('span', 'slc-was'));
    info.appendChild(pr);
    a.appendChild(media); a.appendChild(info); li.appendChild(a);
    return setup(li);
  }
  function card(i) { return cards[i] || (cards[i] = make(i)); }

  var sizeSet = {};
  D.forEach(function (p) { p.vs.forEach(function (v) { sizeSet[v.b] = true; }); });
  var sizes = Object.keys(sizeSet).sort(function (a, b) { return parseFloat(a) - parseFloat(b); });

  var gc = {};
  D.forEach(function (p) { if (p.vs.length) gc[p.g] = (gc[p.g] || 0) + 1; });
  var GROUPS = [['all', 'Alle']].concat(Object.keys(gc).sort(function (a, b) { return gc[b] - gc[a]; }).map(function (g) { return [g, g]; }));

  var params = new URLSearchParams(location.search);
  var state = {
    size: (function (s) { return MERGE[s] || s; })(params.get('str') || read('slcSize') || ''),
    group: params.get('brand') || 'all',
    sort: params.get('sort') || 'pop',
    limit: parseInt(sread('slcLimit'), 10) || STEP
  };
  if (state.size && !sizeSet[state.size]) state.size = '';
  if (!GROUPS.some(function (g) { return g[0] === state.group; })) state.group = 'all';
  if (!/^(pop|disc|asc|desc|new)$/.test(state.sort)) state.sort = 'pop';
  var autoSort = false;
  if (state.size && !params.get('sort')) { state.sort = 'asc'; autoSort = true; }
  sortEl.value = state.sort;

  var allChip = el('button', 'slc-chip', 'Alle');
  allChip.type = 'button'; allChip.setAttribute('data-size', '');
  sizesEl.appendChild(allChip);
  sizes.forEach(function (s) {
    var b = el('button', 'slc-chip', label(s));
    b.type = 'button'; b.setAttribute('data-size', s);
    b.setAttribute('aria-label', 'Størrelse EU ' + label(s));
    sizesEl.appendChild(b);
  });
  GROUPS.forEach(function (g) {
    var b = el('button', 'slc-chip slc-chip--pill', g[1] + ' <small></small>');
    b.type = 'button'; b.setAttribute('data-group', g[0]);
    edsEl.appendChild(b);
  });

  function pct(v) { return v.cmp > v.price ? Math.round((1 - v.price / v.cmp) * 100) : 0; }

  /* Vælg den variant der vises: billigste i valgt størrelse, ellers billigste samlet */
  function pick(i) {
    var vs = D[i].vs, best = null;
    for (var k = 0; k < vs.length; k++) {
      if (state.size && vs[k].b !== state.size) continue;
      if (!best || vs[k].price < best.price) best = vs[k];
    }
    return best;
  }
  function maxDisc(i) {
    var m = 0, vs = D[i].vs;
    for (var k = 0; k < vs.length; k++) { if (state.size && vs[k].b !== state.size) continue; m = Math.max(m, pct(vs[k])); }
    return m;
  }

  function render() {
    var matches = [], groupCounts = { all: 0 }, picked = new Array(D.length);
    for (var i = 0; i < D.length; i++) {
      var v = pick(i);
      picked[i] = v;
      if (!v) continue;
      groupCounts.all++;
      groupCounts[D[i].g] = (groupCounts[D[i].g] || 0) + 1;
      if (state.group === 'all' || D[i].g === state.group) matches.push(i);
    }

    function price(i) { return picked[i].price; }
    if (state.sort === 'asc') matches.sort(function (a, b) { return price(a) - price(b) || a - b; });
    else if (state.sort === 'desc') matches.sort(function (a, b) { return price(b) - price(a) || a - b; });
    else if (state.sort === 'disc') matches.sort(function (a, b) { return maxDisc(b) - maxDisc(a) || a - b; });
    else if (state.sort === 'new') matches.sort(function (a, b) { return D[b].t - D[a].t || a - b; });

    var inMatch = {};
    matches.forEach(function (i, pos) { inMatch[i] = pos; });
    /* Kun kort, der skal vises, bygges; allerede byggede kort beholdes i DOM'en (skjult) */
    var frag = document.createDocumentFragment();
    matches.forEach(function (i, pos) { if (pos < state.limit || cards[i]) frag.appendChild(card(i)); });
    cards.forEach(function (c, i) { if (c && !(i in inMatch)) frag.appendChild(c); });
    grid.appendChild(frag);

    cards.forEach(function (c, i) {
      if (!c) return;
      var pos = inMatch[i];
      c.classList.toggle('is-out', pos === undefined);
      c.classList.toggle('is-hidden', pos !== undefined && pos >= state.limit);
      var v = picked[i];
      if (!v) return;
      var several = !state.size && D[i].vs.length > 1;
      c._now.textContent = (several ? 'Fra ' : '') + v.fmt;
      c._was.textContent = v.cmp > v.price ? v.fcmp : '';
      var d = maxDisc(i);
      c._disc.hidden = !d;
      c._disc.textContent = d ? ((several || (state.size && D[i].vs.filter(function (x) { return x.b === state.size; }).length > 1)) ? 'Op til -' : '-') + d + '%' : '';
      c._a.href = state.size ? c._base + '?variant=' + v.id : c._base;
    });

    [].forEach.call(sizesEl.children, function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-size') === state.size ? 'true' : 'false'); });
    [].forEach.call(edsEl.children, function (b) {
      var g = b.getAttribute('data-group');
      b.setAttribute('aria-pressed', g === state.group ? 'true' : 'false');
      b.querySelector('small').textContent = groupCounts[g] || 0;
      b.disabled = !groupCounts[g] && g !== state.group;
      b.style.opacity = b.disabled ? '.4' : '';
    });

    countEl.innerHTML = '<strong>' + matches.length + '</strong> ' + (matches.length === 1 ? 'model' : 'modeller') + (state.size ? ' i str. ' + label(state.size) : '');
    emptyEl.hidden = matches.length > 0;
    var left = matches.length - state.limit;
    moreWrap.hidden = left <= 0;
    if (left > 0) moreBtn.textContent = 'Vis flere (' + left + ')';

    var q = new URLSearchParams(location.search);
    if (state.size) q.set('str', state.size); else q.delete('str');
    if (state.group !== 'all') q.set('brand', state.group); else q.delete('brand');
    if (state.sort !== 'pop' && !autoSort) q.set('sort', state.sort); else q.delete('sort');
    var qs = q.toString();
    try { history.replaceState(history.state, '', location.pathname + (qs ? '?' + qs : '') + location.hash); } catch (e) {}
  }

  sizesEl.addEventListener('click', function (e) {
    var b = e.target.closest('[data-size]');
    if (!b) return;
    var s = b.getAttribute('data-size');
    state.size = (s === state.size) ? '' : s;
    if (state.size) { if (state.sort === 'pop' || autoSort) { state.sort = 'asc'; autoSort = true; } }
    else if (autoSort) { state.sort = 'pop'; autoSort = false; }
    sortEl.value = state.sort;
    state.limit = STEP; swrite('slcLimit', STEP);
    store('slcSize', state.size || null);
    render();
  });
  edsEl.addEventListener('click', function (e) {
    var b = e.target.closest('[data-group]');
    if (!b || b.disabled) return;
    state.group = b.getAttribute('data-group');
    state.limit = STEP; swrite('slcLimit', STEP);
    render();
  });
  sortEl.addEventListener('change', function () { state.sort = sortEl.value; autoSort = false; render(); });
  moreBtn.addEventListener('click', function () { state.limit += STEP; swrite('slcLimit', state.limit); render(); });
  document.getElementById('slc-reset').addEventListener('click', function () {
    state.size = ''; state.group = 'all'; state.sort = 'pop'; sortEl.value = 'pop'; autoSort = false;
    store('slcSize', null); render();
  });

  /* Musehjul scroller chip-rækkerne vandret */
  [].forEach.call(root.querySelectorAll('.slc-scroll'), function (sc) {
    sc.addEventListener('wheel', function (e) {
      if (sc.scrollWidth <= sc.clientWidth + 1 || Math.abs(e.deltaX) > Math.abs(e.deltaY)) return;
      var max = sc.scrollWidth - sc.clientWidth;
      if ((e.deltaY < 0 && sc.scrollLeft <= 0) || (e.deltaY > 0 && sc.scrollLeft >= max - 1)) return;
      sc.scrollLeft += e.deltaY;
      e.preventDefault();
    }, { passive: false });
  });

  var intro = root.querySelector('.slc-intro');
  if (intro) {
    var itxt = intro.querySelector('.slc-intro__txt'), btn = intro.querySelector('.slc-intro__more');
    if (itxt.scrollHeight > itxt.clientHeight + 2) {
      btn.hidden = false;
      btn.addEventListener('click', function () {
        var open = intro.classList.toggle('is-open');
        btn.textContent = open ? 'Vis mindre' : 'Læs mere';
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }
  }

  /* Sticky bar under (evt. skjult) header */
  var bar = document.getElementById('slc-bar');
  var hw = document.querySelector('sticky-header, .header-wrapper');
  var header = hw ? (hw.querySelector('.header') || hw) : null;
  var ticking = false;
  function place() {
    ticking = false;
    var top = 0;
    if (header) { var r = header.getBoundingClientRect(); if (r.top <= 1 && r.bottom > 0 && r.bottom < 160) top = Math.round(r.bottom); }
    root.style.setProperty('--slc-top', top + 'px');
    bar.classList.toggle('is-stuck', bar.getBoundingClientRect().top <= top + 1 && window.scrollY > 0);
  }
  window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(place); } }, { passive: true });
  window.addEventListener('resize', place);
  place();

  render();
  var sel = sizesEl.querySelector('[aria-pressed="true"]');
  if (sel && sel.getAttribute('data-size')) sizesEl.scrollLeft = Math.max(0, sel.offsetLeft - sizesEl.offsetLeft - 40);
}
})();
